export class SendChatMessageModel {
    public subscriberId: string;
    public advertiserId: string;
    public subscriberChatId: string;
    public eventId: string;
    public message: string;
}